import { render, staticRenderFns } from "./dieu-khoan-su-dung-chinh-sach-bao-mat.vue?vue&type=template&id=3fc0f751&scoped=true&"
import script from "./dieu-khoan-su-dung-chinh-sach-bao-mat.vue?vue&type=script&lang=js&"
export * from "./dieu-khoan-su-dung-chinh-sach-bao-mat.vue?vue&type=script&lang=js&"
import style0 from "./dieu-khoan-su-dung-chinh-sach-bao-mat.vue?vue&type=style&index=0&id=3fc0f751&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc0f751",
  null
  
)

export default component.exports